<template>
  <footer id="footer" class="footer">
    <div class="footer-wrap">
      <div class="footer-inner">
        <div class="footer-up clearfix">
          <div class="footer-logo fl">
            <img src="./imgs/logo.png" alt="东福福利网" class="footer__logo" />
          </div>
          <div class="footer-guide fr clearfix" v-if="foots && foots.length">
            <dl
              class="footer-guide__item fl"
              v-for="foot in foots"
              :key="foot.id"
            >
              <dt>{{ foot.name }}</dt>
              <dd v-for="item in foot.subItems" :key="item.id">
                <a
                  :href="
                    item.type === 1
                      ? item.targetLink
                      : `/static/article?id=${item.id}&city=${city}`
                  "
                  :title="item.name"

                  :target="isFeishuOrDingding ? '_self' : '_blank'"

                  >
                  {{ item.name }}
                </a>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="footer-down tc">
        <p>
          <span
            >Copyright &copy; 2012–2019
            <a :href="`${skipLink}?city=${city}`" 
            :target="isFeishuOrDingding ? '_self' : '_blank'"
              >{{TLang('上海东福网络科技有限公司','home')}}.</a
            >
            All Rights Reserved
            <a href="http://www.beian.miit.gov.cn" target="_blank"
              >沪ICP备16001915号</a
            ></span
          >
          <span
            ><a :href="`/static/medicalcert?city=${city}`" 
              :target="isFeishuOrDingding ? '_self' : '_blank'"
              >{{TLang('第二类医疗器械经营备案凭证','home')}}</a
            ></span
          >
          <span
            ><a :href="`/static/publishcert?city=${city}`" 
              :target="isFeishuOrDingding ? '_self' : '_blank'"
              >{{TLang('出版物经营许可证','home')}}</a
            ></span
          >
        </p>
        <p>
          <span
            ><a :href="`/static/winecert?city=${city}`" 
              :target="isFeishuOrDingding ? '_self' : '_blank'"
              >{{TLang('酒类商品零售许可证','home')}}</a
            ></span
          >
          <span
            ><a :href="`/static/electriccert?city=${city}`" 
            :target="isFeishuOrDingding ? '_self' : '_blank'"
              >{{TLang('增值电信业务经营许可证','home')}}</a
            ></span
          >
          <span
            ><a :href="`/static/privatelegal?city=${city}`" 
            :target="isFeishuOrDingding ? '_self' : '_blank'"
              >{{TLang('隐私政策','home')}}</a
            ></span
          >
          <span>{{TLang('违法和不良信息举报电话','home')}}</span>
          <span
            ><a :href="`/static/prePayRule?city=${city}`" 
            :target="isFeishuOrDingding ? '_self' : '_blank'"
              >{{TLang('预付卡章程','home')}}</a
            ></span
          >
        </p>
        <p>
          <span
            ><a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502004928"
              ><img
                src="./imgs/police@2x.png"
                class="footer-police"
              />{{TLang('沪公网安备','home')}}</a
            ></span
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { getQueryString } from "../../utils";
import { getFooterContent } from "./api";
export default {
  data() {
    return {
      foots: [],
      skipLink: "/static/license",
      city: ""
    };
  },
  async created() {
    this.city = getQueryString("city");
    this.getFooterContent();
  },

  methods: {
    async getFooterContent() {
      const res = await getFooterContent({
        location: 3
      });
      if (res.code !== 0) return;
      this.foots = res.body ? res.body.sort((a, b) => a.sort - b.sort) : [];
    }
  }
};
</script>

<style lang="less" scoped>
.footer {
  position: relative;
  margin-top: -330px;
  height: 330px;
  background-color: #fafafa;
  &-wrap {
    border-top: 1px solid #eee;
    min-width: 1200px;
    box-sizing: border-box;
    height: 210px;
  }
  &-inner {
    display: table;
    height: 100%;
    .wrapper();
  }
  &-guide {
    &__item {
      font-size: 14px;
      float: left;
      // width: 130px;
      margin-right: 80px;
      > dt {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: 5px;
          left: -5px;
          width: 2px;
          height: 12px;
          background-color: #333;
        }
      }
      > dd {
        margin-top: 2px;
        > a {
          display: inline-block;
          color: #8d8d8d;
          &:hover {
            color: #619ee0;
          }
        }
      }
      // &:first-child {
      //   width: 170px;
      // }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &-logo {
    // width: 820px;
    > img {
      width: 510px;
      vertical-align: top;
    }
  }
  &-up {
    display: table-cell;
    vertical-align: middle;
  }
  &-down {
    color: #999;
    padding-top: 12px;
    border-top: 1px solid #eee;
    > p {
      margin-top: 5px;
      > span {
        margin: 0 10px;
      }
    }
    a {
      color: #999;
      cursor: pointer;
      &:hover {
        color: #3d96e2;
      }
    }
  }
  &-police {
    width: 16px;
    vertical-align: top;
    margin-top: 1px;
    margin-right: 3px;
  }
}
</style>
